import "./CustomDetailsComments.css";

import { useLayoutEffect, useState } from "react";

import { useLocalStorage } from "hooks/useLocalStorage";
import CommentsBox from "pages/EstimateViewer/components/CommentsBox/CommentsBox";

const CustomDetailsComments = ({ rowObj, colSpan, setVisible, api, postInitBody, setFetchStatus, setFetchStatusText, successPostAct }) => {
	const [inputComment, setInputLocalComment] = useState("");
	const { getLsItem, setLsItem } = useLocalStorage();

	const getLsComments = () => {
		const lsCommentsMap = getLsItem({ key: "commentsMap" });
		if (lsCommentsMap) {
			return JSON.parse(lsCommentsMap) ?? {};
		} else {
			return {};
		}
	};

	useLayoutEffect(() => {
		const commentsMap = getLsComments();
		if (commentsMap[rowObj?.key]) {
			setInputLocalComment(commentsMap[rowObj?.key] ?? "");
		}
	}, [rowObj?.key]); // eslint-disable-line react-hooks/exhaustive-deps

	const setInputComment = (text) => {
		setInputLocalComment(text);
		const commentsMap = getLsComments();
		if (text === "") {
			delete commentsMap?.[rowObj?.key];
		} else {
			commentsMap[rowObj?.key] = text;
		}
		setLsItem({ key: "commentsMap", value: JSON.stringify(commentsMap) });
	};

	const postComment = (text) => {
		setFetchStatus("loading");
		const prom = api.postRowComment({ ...postInitBody, text: text });
		prom.then((response) => {
			setFetchStatus("success");
			setInputComment("");
			successPostAct();
		}).catch((error) => {
			console.error(error);
			setFetchStatus("failed");
		});
	};

	const deleteComment = (commentObj) => {
		setFetchStatus("loading");
		const prom = api.deleteRowComment(commentObj.id);
		prom.then((response) => {
			setFetchStatus("success");
			successPostAct();
		}).catch((error) => {
			if (error?.response?.data?.detail != null) setFetchStatusText(error.response.data.detail);
			setFetchStatus("failed");
		});
	};

	const editComment = ({ commentObj, text }) => {
		setFetchStatus("loading");
		const prom = api.editRowComment({ commentId: commentObj.id, text });
		prom.then((response) => {
			setFetchStatus("success");
			successPostAct();
		}).catch((error) => {
			if (error?.response?.data?.detail != null) setFetchStatusText(error.response.data.detail);
			setFetchStatus("failed");
		});
	};

	return (
		<>
			<tr className="CustomDetailsCommentsRow">
				<td colSpan={colSpan}>
					<CommentsBox
						rowObj={rowObj}
						inputComment={inputComment}
						setInputComment={setInputComment}
						setVisible={setVisible}
						postComment={postComment}
						deleteComment={deleteComment}
						editComment={editComment}
					/>
				</td>
			</tr>
		</>
	);
};

export default CustomDetailsComments;
